import { useTranslation } from "react-i18next";

const BusinessLicense = ({
    loading,
    data
}) => {
    const { t } = useTranslation();

    return (
        <div className="card-body px-4">
            <h5 className="account-section-title py-2">Business License</h5>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col d-flex align-items-center justify-content-center position-relative mb-3">
                            {data?.businessDetail?.license ? (
                                data.businessDetail.license.toLowerCase().endsWith(".pdf") ? (
                                    <iframe
                                        src={`https://docs.google.com/gview?url=${encodeURIComponent(data?.businessDetail?.license)}&embedded=true`}
                                        title="PDF Preview"
                                        className="w-100 rounded shadow-sm preview-selected-file"
                                        style={{ height: "500px", border: "none" }}
                                        onError={(e) => {
                                            // Fallback to direct URL if Google viewer fails
                                            e.target.src = data?.businessDetail?.license;
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={data.businessDetail.license}
                                        alt="Preview"
                                        className="img-fluid rounded shadow-sm p-2 preview-selected-file"
                                    />
                                )
                            ) : (
                                <p className="text-muted">No file available</p>
                            )}
                        </div>
                    </div>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0"
                                onClick={() => { }}
                            >
                                {t("myPage.accountInformation.subMenu.paymentMethod.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default BusinessLicense;
